module.exports = function (e) {
    function t(a) {
        if (n[a]) return n[a].exports;
        var i = n[a] = {exports: {}, id: a, loaded: !1};
        return e[a].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports
    }

    var n = {};
    return t.m = e, t.c = n, t.p = "", t(0)
}([function (e, t, n) {
    "use strict";

    function a(e) {
        return e && e.__esModule ? e : {"default": e}
    }

    var i = n(1), l = a(i);
    e.exports = l["default"]
}, function (e, t, n) {
    "use strict";

    function a(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    var i = function () {
        function e(e, t) {
            for (var n = 0; n < t.length; n++) {
                var a = t[n];
                a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a)
            }
        }

        return function (t, n, a) {
            return n && e(t.prototype, n), a && e(t, a), t
        }
    }();
    Object.defineProperty(t, "__esModule", {value: !0});
    var l = n(2), s = "floatl--focused", r = "floatl--active", u = "floatl--multiline", o = function () {
        function e(t) {
            a(this, e), this.element = (0, l.getElement)(t), this.label = this.element.querySelectorAll(".floatl__label")[0], this.input = this.element.querySelectorAll(".floatl__input")[0], this._bindListeners(), this._init()
        }

        return i(e, [{
            key: "_bindListeners", value: function () {
                var e = this;
                (0, l.addEventListener)(this.input, "focus", function () {
                    (0, l.addClass)(e.element, s)
                }), (0, l.addEventListener)(this.input, "blur", function () {
                    (0, l.removeClass)(e.element, s)
                });
                for (var t = ["keyup", "blur", "change"], n = 0; n < t.length; n++) {
                    var a = t[n];
                    (0, l.addEventListener)(this.input, a, function () {
                        return e._handleChange()
                    })
                }
            }
        }, {
            key: "_init", value: function () {
                "TEXTAREA" === this.input.tagName && (0, l.addClass)(this.element, u), this._handleChange()
            }
        }, {
            key: "_handleChange", value: function () {
                "" === this.input.value ? (0, l.removeClass)(this.element, r) : (0, l.addClass)(this.element, r)
            }
        }]), e
    }();
    t["default"] = o
}, function (e, t) {
    "use strict";

    function n(e) {
        if (e.tagName) return e;
        if (jQuery && e instanceof jQuery) return e.get(0);
        throw new TypeError("%{element} 'is not a valid element.\n                        Valid options are: DOM Element, jQuery.'")
    }

    function a(e, t) {
        e.classList ? e.classList.add(t) : e.className += " %{className}"
    }

    function i(e, t) {
        e.classList ? e.classList.remove(t) : (re = new RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"), e.className = e.className.replace(re, " "))
    }

    function l(e, t, n) {
        e.addEventListener ? e.addEventListener(t, n) : e.attachEvent("on%{eventName}", function () {
            n.call(e)
        })
    }

    Object.defineProperty(t, "__esModule", {value: !0}), t.getElement = n, t.addClass = a, t.removeClass = i, t.addEventListener = l
}]);
//# sourceMappingURL=floatl.min.js.map
